import React from 'react';
import { TemplateBuilderContainer } from './Components/TemplateBuilderContainer';
import {
  TemplateBuilder,
  TemplateBuilderFactory,
} from './Components/TemplateBuilderFactory';
import { TemplateBuilderInputTriggerSection } from './Components/TemplateBuilderInputTriggerSection';

export const BulletproofCaptureBuilder: TemplateBuilder = ({
  maxFollowUpCounts,
}) => (
  <TemplateBuilderFactory template="bulletproof_capture" {...maxFollowUpCounts}>
    {props => {
      return (
        <TemplateBuilderContainer
          enabled={!props.busy && props.isValid}
          confirm={props.confirm}
        >
          <TemplateBuilderInputTriggerSection>
            <div>
              On {props.channelName}, when someone {props.triggersSelect}, send{' '}
              {props.channelMessageName} to attempt to collect their{' '}
              {props.collectionSelect}, then ask them{' '}
              {props.qualifyingQuestionSelect}. This includes explicit
              permission to re-engage them later.
            </div>
          </TemplateBuilderInputTriggerSection>
        </TemplateBuilderContainer>
      );
    }}
  </TemplateBuilderFactory>
);
